// Shared scaffold for the Game Plan print assets: brand header/footer, base
// styles, and a helper that writes a self-contained doc to a new window and
// prints it. Keeps each asset file small and the sheets visually consistent.

export const esc = (s: string): string =>
  String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const BASE_CSS = `
  @page { margin: 14mm; }
  * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body { margin: 0; font-family: ui-sans-serif, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; color: #16241E; background: #FBF6EC; }
  .sheet { max-width: 760px; margin: 0 auto; padding: 8px; }
  .hdr { background: #0C3D2D; color: #FBF6EC; border-radius: 12px; padding: 22px 26px; }
  .wm { font-weight: 800; letter-spacing: .18em; font-size: 12px; opacity: .8; }
  .eyebrow { font-size: 11px; letter-spacing: .22em; text-transform: uppercase; color: #E2D1A7; margin-top: 10px; }
  .hdr h1 { margin: 4px 0 0; font-size: 30px; font-weight: 800; }
  .rule { height: 3px; width: 54px; background: #B58F2D; border-radius: 3px; margin: 12px 0 10px; }
  .sub { font-size: 13px; color: rgba(251,246,236,.82); }
  h2 { font-size: 14px; font-weight: 700; color: #0C3D2D; text-transform: uppercase; letter-spacing: .05em; margin: 24px 0 10px; display: flex; align-items: center; gap: 10px; }
  h2::before { content: ""; width: 24px; height: 3px; background: #B58F2D; border-radius: 3px; }
  .card { background: #FFFDF8; border: 1px solid #E6DFCF; border-radius: 10px; padding: 16px 18px; break-inside: avoid; page-break-inside: avoid; }
  .ftr { margin-top: 22px; padding-top: 12px; border-top: 1px solid #E6DFCF; display: flex; justify-content: space-between; font-size: 11px; color: #6C756D; }
  .ftr b { color: #0C3D2D; }
  .box { flex: none; width: 17px; height: 17px; border: 1.8px solid #0C3D2D; border-radius: 4px; background: #fff; }
`;

export function header(eyebrow: string, title: string, subtitle: string): string {
  return `<div class="hdr"><div class="wm">TEE BOX</div><div class="eyebrow">${esc(
    eyebrow,
  )}</div><h1>${esc(title)}</h1><div class="rule"></div><div class="sub">${esc(
    subtitle,
  )}</div></div>`;
}

export function footer(right: string): string {
  return `<div class="ftr"><span><b>Tee Box</b> · HQ Owner Playbook</span><span>${esc(
    right,
  )}</span></div>`;
}

/** Writes a full branded print document and opens it to print. */
export function openPrintDoc(docTitle: string, extraCss: string, bodyInner: string): void {
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(
    docTitle,
  )}</title><style>${BASE_CSS}${extraCss}</style></head><body><div class="sheet">${bodyInner}</div><script>window.onload=function(){setTimeout(function(){window.print();},250);};</script></body></html>`;
  const w = window.open('', '_blank', 'width=900,height=1000');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
